import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { OpenModalContext } from 'common/containers/ModalContainer';
import LazyLoadedImage from 'common/LazyLoadedImage';
import PhotoViewer from 'common/PhotoViewer';
import Tappable from 'common/Tappable';
import withContexts from 'common/util/withContexts';

import 'css/components/post/_CreatePostFormImages.scss';

class CreatePostFormImages extends Component {
  static propTypes = {
    imageURLs: PropTypes.array,
    onImageDeleted: PropTypes.func,
    openModal: PropTypes.func,
  };

  state = {
    loadedImageURLs: {},
  };

  onImageTapped = (index) => {
    this.props.openModal(PhotoViewer, {
      imageURLs: this.props.imageURLs,
      defaultIndex: index,
    });
  };

  onRemoveTapped = (index) => {
    this.props.onImageRemoved(index);
  };

  onImageLoad = (imageURL) => {
    this.setState((state) => ({
      loadedImageURLs: {
        ...state.loadedImageURLs,
        [imageURL]: true,
      },
    }));
  };

  render() {
    const { imageURLs } = this.props;
    if (imageURLs.length === 0) {
      return null;
    }

    const images = [];
    const { loadedImageURLs } = this.state;

    imageURLs.forEach((imageURL, i) => {
      const isImageLoaded = loadedImageURLs[imageURL];

      images.push(
        <div key={i} className="imagePreview">
          <Tappable onTap={this.onImageTapped.bind(this, i)}>
            <LazyLoadedImage src={imageURL} onLoad={this.onImageLoad.bind(this, imageURL)} />
          </Tappable>
          {isImageLoaded && (
            <Tappable onTap={this.onRemoveTapped.bind(this, i)}>
              <span className="icon icon-x" />
            </Tappable>
          )}
        </div>
      );
    });

    return <div className="createPostFormImages">{images}</div>;
  }
}

export default withContexts({ openModal: OpenModalContext })(CreatePostFormImages);
